import React, { useContext } from "react";
import { LegacyCard as Card, Text, Collapsible, BlockStack } from "@shopify/polaris";
import { DropZone } from "lib/components";

// import context
import { PrivateContext } from "lib/context";

const File = (props) => {
  const { handleAddImage, removeImage, allowMultiple, data } = props;
  const { cms } = useContext(PrivateContext) || {};
  const updateImageData = [];

  if (data && data.length) {
    data.forEach((item) => {
      const regex = new RegExp('data:image/([a-zA-Z]*);base64,([^"]*)');
      if (!regex.test(item)) {
        updateImageData.push({ url: item });
      }
    });
  }

  const propsValues = {
    existingImageList: updateImageData || [],
  };

  if (!allowMultiple) {
    propsValues.fileList = (!allowMultiple ? (!updateImageData.length && data) || [""] : []) || [];
  }

  return (
    <Collapsible open>
      <Card title={["File"]}>
        <Card.Section>
          <BlockStack gap="4">
            {cms("section.cover.subDescription")}
            <small>(recommended size 2000px X 400px)</small>
          </BlockStack>
          <br />
          <DropZone
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...propsValues}
            id="dropZone"
            onAdd={handleAddImage}
            onRemove={removeImage}
            removeExistingImage={removeImage}
            allowMultiple={allowMultiple}
            allowedTypes={["gif", "jpeg", "jpg", "png", "svg", "webp", "avif"]}
            size={10}
            sizeType="MB"
          />
          <br />
          <Text variant="bodySm" as="p">
            {cms("section.cover.value.defaultText")}
          </Text>
        </Card.Section>
      </Card>
    </Collapsible>
  );
};

export default File;
